import { useAuth } from "@/auth/provider/AuthContext";
import { useEffect, useState } from "react";
import * as client from "./client";
import { client as axiosClient } from "./client.gen/client.gen";

export * from "./client.gen/types.gen";

export const useViaductApiNoAuth = () => {
  return client;
};

export const useViaductApi = () => {
  const { getToken, authenticated } = useAuth();
  const [clientInititialized, setClientInitialized] = useState(false);

  useEffect(() => {
    if (clientInititialized || !authenticated) {
      return;
    }

    axiosClient.instance.interceptors.request.use(async (config) => {
      config.headers.Authorization = `Bearer ${await getToken()}`;
      return config;
    });

    setClientInitialized(true);
  }, [authenticated]);

  return { client, clientInititialized };
};
